<template>
  <div>
    <report-unprocessed-documents ref="ReportUnprocessedDocuments" />
    <config-mandatory-tip ref="ConfigMandatoryTip" />
    <change-date-documents ref="ChangeDateDocuments" />
    <config-print-data-shop ref="ConfigPrintDataShop" />
  </div>
</template>
<script>

  export default {
    components: {
      ReportUnprocessedDocuments: () => import('./components/ReportUnprocessedDocuments'),
      ConfigMandatoryTip: () => import('./components/MandatoryTipConfigs'),
      ChangeDateDocuments: () => import('./components/ChangeDateDocuments'),
      ConfigPrintDataShop: () => import('./components/PrintDataShopConfigs'),
    },
  }
</script>